import { useState, ReactNode } from 'react';
import { Header } from './Header';
import { AdminSidebar } from './AdminSidebar';
import { ToastContainer } from '../Shared/ToastContainer';
import { WhatsNewModal } from '../Shared/WhatsNewModal';

interface AdminShellProps {
  children: ReactNode;
}

export function AdminShell({ children }: AdminShellProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-paper flex">
      <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="flex-1 flex flex-col min-h-screen min-w-0">
        <Header onMenuClick={() => setSidebarOpen(true)} />

        <main className="flex-1 flex flex-col min-h-0 overflow-auto">
          <div className="px-6 py-6 flex flex-col min-h-0 flex-1">
            {children}
          </div>
        </main>
      </div>

      <ToastContainer />
      <WhatsNewModal />
    </div>
  );
}
